module.exports = __webpack_public_path__ + "img/ZM3.87af1ee1.png";